import { SetFormAliasAction, MrmEnvironment, SetMrmEnvironmentAction, SetDebugAction, SetPageIdAction, SetLocaleAction, GlobalState, SetStateAction } from "./types";

export enum GlobalStateDataTypes {
    SetFormAlias = 'DATA/SET-FORM-ALIAS',
    SetMrmEnvironment = 'DATA/SET-MRM-ENVIRONMENT',
    SetDebug = 'DATA/SET-DEBUG',
    SetPageId = 'DATA/SET-PAGE-ID',
    SetLocale = 'DATA/SET-LOCALE',
    SetState = 'DATA/SET-STATE'
}

export const setFormAlias = (alias: string): SetFormAliasAction => ({
    type: GlobalStateDataTypes.SetFormAlias,
    payload: { alias },
});

export const setMrmEnvironment = (environment: MrmEnvironment): SetMrmEnvironmentAction => ({
    type: GlobalStateDataTypes.SetMrmEnvironment,
    payload: { environment },
});

export const setDebug = (flag: boolean): SetDebugAction => ({
    type: GlobalStateDataTypes.SetDebug,
    payload: { flag },
});

export const setPageId = (id: number): SetPageIdAction => ({
    type: GlobalStateDataTypes.SetPageId,
    payload: { id },
});

export const setLocale = (locale: string): SetLocaleAction => ({
    type: GlobalStateDataTypes.SetLocale,
    payload: { locale },
});

export const setGlobalState = (state: Partial<GlobalState>): SetStateAction => ({
    type: GlobalStateDataTypes.SetState,
    payload: { state }
})